export const FIELD_HEIGHT = '48px';
export const FIELD_RADIUS = '12px';
export const FIELD_TITLE_GAP = '8px';
export const FIELD_ERROR_HELPER_GAP = '8px';
export const FIELD_ICON_INSET = '16px';
export const FIELD_CLEAR_ICON_GAP = '4px';
export const FIELD_MENU_GAP = '8px';

export const FIELD_MENU_SX = {
  mt: FIELD_MENU_GAP,
  borderRadius: FIELD_RADIUS,
} as const;

export const FIELD_ICON_SX = {
  width: '24px',
  height: '24px',
  flexShrink: 0,
} as const;

export const FIELD_ICON_MOBILE_SX = {
  width: '20px',
  height: '20px',
  flexShrink: 0,
} as const;
